import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Stack,
} from "@mui/material";
import SignaturePadField from "../common/SignaturePadField";

/** Draw-your-signature dialog for the investor loan signing flow. */
const InvestorSignatureModal = ({ open, onClose, onSubmit, submitting, error }) => {
  const [signature, setSignature] = React.useState(null);

  React.useEffect(() => {
    if (!open) setSignature(null);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1.5,
          border: (theme) => `1px solid ${theme.palette.border.light}`,
        },
      }}
    >
      <Box sx={{ p: 3 }}>
        <SignaturePadField
          title="Draw Your Signature"
          helper="This will be applied as your legally binding signature"
          height={260}
          disabled={submitting}
          onChange={setSignature}
        />

        {error ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        ) : null}

        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={submitting}
            sx={{
              height: 36,
              px: 2.125,
              borderRadius: 1.25,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              borderColor: "border.light",
              color: "text.strong",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => signature && onSubmit?.(signature)}
            disabled={!signature || submitting}
            startIcon={
              submitting ? (
                <CircularProgress size={14} sx={{ color: "common.white" }} />
              ) : null
            }
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1.25,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              color: "common.white",
              bgcolor: (theme) => theme.palette.accent.blue.solid,
              boxShadow: "none",
              "&:hover": {
                bgcolor: (theme) => theme.palette.accent.blue.actionHover,
                boxShadow: "none",
              },
              "&.Mui-disabled": {
                opacity: 0.5,
                color: (theme) => theme.palette.common.white,
                bgcolor: (theme) => theme.palette.accent.blue.solid,
              },
            }}
          >
            {submitting ? "Submitting…" : "Apply Signature"}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default InvestorSignatureModal;
